import React, { Component, Suspense } from 'react';

//UI
import Typography from "@material-ui/core/Typography";
import SubmitIcon from "../../img/icon-submitted.png";

//librray
import { connect } from 'react-redux';

//component
import { Link } from "react-router-dom";


class Success extends Component {

    render() {
        
        return (
            <div className="submitRequest-inner">
                <Typography component="h1" variant="h3" className="logo-text">VOPS</Typography>
                <br />
                <br />

                <img src={SubmitIcon} alt="Submitted"/>
                
                <br />
                

                <Typography component="h1" variant="h5" className="request-text">Request has been submitted</Typography>
                <Typography component="p" variant="div" className="text-center">
                    You will be notified via email,once your account has been approved.
                </Typography>
                <div className="login-fixed-height">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                    <Typography component="p" className="text-center">
                        <Link to={`/login`}                  
                        >Back to Login page</Link>       
                    </Typography>
                </div>
            </div>                
        );
    }
}


export default connect(state => ({ ...state.reducer.login }), dispatch => ({ dispatch }))(Success);



// WEBPACK FOOTER //
// ./src/containers/Login/_submitRequest.login.js